import React from 'react';

import { PersonalizedProductsQuery } from 'src/personalization/data-layer/types';
import BlueSparkle from 'src/assets/blue-sparkle-icon';
import { DesktopOnly, MobileOnly } from 'shared/components';
import { BlendedPersonalizedProductCarousel } from './blended-carousel';
import { TabbedPersonalizedProductCarousel } from './tabbed-carousel';

type LoggedInProps = {
  personalizedProductsQuery: PersonalizedProductsQuery;
  title?: string;
};

export const LoggedInV2 = (props: LoggedInProps): JSX.Element | null => {
  const { personalizedProductsQuery, title } = props;
  const heading = title ?? 'Recommended for you';
  const subheading = 'Based on your shopping history';
  const icon = <BlueSparkle />;

  return (
    <>
      <MobileOnly mediaQuery='xs'>
        <TabbedPersonalizedProductCarousel
          heading={heading}
          subheading={subheading}
          icon={icon}
          personalizedProductsQuery={personalizedProductsQuery}
        />
      </MobileOnly>

      <DesktopOnly mediaQuery='sm'>
        <BlendedPersonalizedProductCarousel
          heading={heading}
          subheading={subheading}
          icon={icon}
          personalizedProductsQuery={personalizedProductsQuery}
        />
      </DesktopOnly>
    </>
  );
};
